export default __webpack_public_path__ + "static/media/education_app.5236bd72.jpg";